/**
 * @license
 * Copyright 2026 okayest! studios LLC. All Rights Reserved.
 */

const alphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

/** Random ID using the nanoid alphabet, matching IDs generated by the app. */
export function newId(length: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return Array.from(bytes, (b) => alphabet[b & 63]).join('');
}
